<template>
  <div style="display: contents;">
    <template v-if="loading">
      <div
        v-for="(col, colIndex) in header"
        class="body-column"
        :key="col.field"
        :style="styleFromColIndex(colIndex)"
      >
        <div class="table-row-loading" />
      </div>
    </template>
    <template v-else>
      <div
        v-for="(col, colIndex) in header"
        class="body-column"
        :key="col.field"
        :class="{'table-row-active-details': activeDetails}"
        tabindex="-1"
        :title="getTitle(item, col.field)"
        :style="styleFromColIndex(colIndex)"
        @click="handleClick(col, false)"
        @dblclick="handleClick(col, true)"
        @keydown="handleKeydown(col, $event)"
      >
        <span class="no-wrap" :class="[...classesConteudo, { 'conteudo-numerico': col.numerico }]">
          <slot
            v-if="$slots[col.field]"
            :name="col.field"
            :columnValue="getValue(item, col.field)"
            :rowItem="item"
            :index="index"
          />
          <template v-else>
            {{ getValue(item, col.field) }}
          </template>
        </span>
      </div>
    </template>

    <div
      v-if="possuiColunaDeConfiguracao"
      class="body-column"
      :style="configColumnStyle"
    />
  </div>
</template>

<script>
import { obterComNotacaoPonto } from 'src/utils/outro/outro'
import { isString } from 'lodash'

export default {
  name: 'TableRow',
  props: {
    loading: Boolean,
    header: Array,
    index: Number,
    item: [Object, Number],
    activeDetails: Boolean,
    classesConteudo: {
      type: Array,
      default: () => []
    },
    possuiColunaDeConfiguracao: Boolean,
    onClick: Function,
    onKeydown: Function
  },
  computed: {
    configColumnStyle () {
      return {
        'grid-row': `${this.index + 2} / ${this.index + 2}`,
        'grid-column': '-2 / -1'
      }
    }
  },
  methods: {
    styleFromColIndex (colIndex) {
      return {
        // plus 2 because 1 is for header and index starts at 0 and css grid starts at 1
        'grid-row': `${this.index + 2} / ${this.index + 2}`,
        'grid-column': `${colIndex + 1} / ${colIndex + 2}`
      }
    },
    getValue (item, field) {
      return obterComNotacaoPonto(item, field)
    },
    getTitle (item, field) {
      const val = this.getValue(item, field)
      return isString(val) || typeof val === 'number' ? String(val) : null
    },
    handleClick (col, isDoubleClick) {
      if (this.onClick) {
        // Warning: props.item[col.field] passing raw value as before (not necessarily formatted/computed)
        // Original: props.onClick(props.item, props.item[i.field], props.item.realIndex, isDoubleClick)
        this.onClick(this.item, this.item[col.field], this.item.realIndex, isDoubleClick)
      }
    },
    handleKeydown (col, event) {
      if (event.key === 'Enter') {
        this.handleClick(col, true)
      } else {
        if (this.onKeydown) {
          this.onKeydown({ event, rowNumber: this.index })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.table-row-active-details {
  background-color: var(--superficie-sutil) !important;
}
</style>

<style lang="scss" scoped>
.table-row-loading {
  width: 30%;
  min-width: 44px;
  height: 14px;
  border-radius: 999px;
  background-color: var(--superficie-sutil);
}

// Coluna numérica: ative via headerItems[n].numerico = true na SmartTable.
// Alinha o conteúdo à direita e aplica números tabulares para colunas de
// horas, valores e contagens.
.conteudo-numerico {
  font-variant-numeric: tabular-nums;
  justify-self: end;
  text-align: right;
  width: 100%;
}
</style>
